import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalInterceptor,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
} from '@azure/msal-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationModule } from './navigation/navigation.module';
import { DataTablesModule } from 'angular-datatables';
import { JwtInterceptor } from './auth/helpers';
import { ErrorInterceptor } from './shared/helpers';
import { environment } from '../environments/environment';
import { providePrimeNG } from 'primeng/config';
import MyPreset from '../styles/theme';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NavigationModule,
    RouterModule,
    DataTablesModule,
    ReactiveFormsModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.msalConfig.clientId, // Replace with your Application (client) ID
          authority: environment.msalConfig.authority, // Replace with your Azure AD tenant ID
          redirectUri: window.location.origin, // Your redirect URI
          postLogoutRedirectUri: environment.msalConfig.postLogoutRedirectUri, // Optional: Your post-logout redirect URI
        },
        cache: {
          cacheLocation: environment.cacheConfig
            .cacheLocation as BrowserCacheLocation, // This configures where your cache will be stored
          storeAuthStateInCookie:
            environment.cacheConfig.storeAuthStateInCookie, // Set to true for IE 11 or Edge
        },
      }),
      {
        interactionType: InteractionType.Redirect, // MSAL Guard Configuration
        authRequest: {
          scopes: ['user.read'], // Define the scopes you want to request
        },
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['user.read']],
          // Add other protected resources here
        ]),
      },
    ),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    MsalService,
    MsalGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false, // stops PrimeNG from switching CSS vars based on system/browser dark mode
        },
      },
    }),
    provideAnimationsAsync(),
  ],
})
export class AppModule {}
